import { lazy } from "react";
import { AppRoute } from "../../../models/AppRoute";
import { DCPPathNames, UserPermissions } from "../../../utilities/Constants";

//#region  Lazy-loaded component
const DealershipDashboard = lazy(
    () => import("../../dashboard/views/Dashboard")
);
const CustomerAccounts = lazy(() => import("../views/CustomerAccounts"));
const DealerConfiguration = lazy(() => import("../views/DealerConfiguration"));
const AuditHistory = lazy(() => import("../views/AuditHistory"));
const DealershipUserAccounts = lazy(
    () => import("../views/DealershipUserAccounts")
);
const DealershipSettingsConfiguration = lazy(
    () => import("../views/DealershipSettingsConfiguration")
);
const CustomerSignupRequests = lazy(
    () => import("../views/CustomerSignupRequests")
);
//#endregion

const dealerRoutes: AppRoute[] = [
    {
        path: DCPPathNames.DEALERSHIP_DASHBOARD_PATH,
        name: "Dashboard",
        element: <DealershipDashboard />,
        meta: {
            requiresAuthorization: true,
            authorize: [UserPermissions.MANAGE_CUSTOMER_ACCOUNTS],
            menu: {
                label: "Dashboard",
                icon: ["fas", "chart-line"],
            },
        },
    },
    {
        path: DCPPathNames.CUSTOMER_ACCOUNTS_PATH,
        name: "Customers",
        meta: {
            requiresAuthorization: true,
            authorize: [UserPermissions.MANAGE_CUSTOMER_ACCOUNTS],
            menu: {
                label: "Customers",
                icon: ["fas", "users-rays"],
            },
        },
        children: [
            {
                path: DCPPathNames.CUSTOMER_ACCOUNTS_REGISTERED_PATH,
                name: "Registered Customers",
                element: <CustomerAccounts />,
                meta: {
                    requiresAuthorization: true,
                    authorize: [UserPermissions.MANAGE_CUSTOMER_ACCOUNTS],
                    menu: {
                        label: "Registered Customers",
                    },
                },
            },
            {
                path: DCPPathNames.CUSTOMER_ACCOUNTS_INVITE_PATH,
                name: "Invite Customers",
                element: <CustomerAccounts />,
                meta: {
                    requiresAuthorization: true,
                    authorize: [UserPermissions.MANAGE_CUSTOMER_ACCOUNTS],
                    menu: {
                        label: "Invite Customers",
                    },
                },
            },
            {
                path: DCPPathNames.CUSTOMER_REQUESTS_PATH,
                name: "Customer Requests",
                element: <CustomerSignupRequests />,
                meta: {
                    requiresAuthorization: true,
                    authorize: [UserPermissions.MANAGE_DEALERSHIP_ACCOUNTS],
                    menu: {
                        label: "Customer Requests",
                    },
                },
            },
        ],
    },
    {
        path: DCPPathNames.DEALERSHIP_CONFIGURATION_PATH,
        name: "Dealer Configuration",
        element: <DealerConfiguration />,
        meta: {
            requiresAuthorization: true,
            authorize: [UserPermissions.ONBOARD_DEALERSHIPS],
            menu: {
                label: "Dealership Configuration",
                icon: ["fas", "tractor"],
            },
        },
    },
    {
        path: DCPPathNames.DEALERSHIP_USERS_PATH,
        name: "Dealership Users",
        element: <DealershipUserAccounts />,
        meta: {
            requiresAuthorization: true,
            authorize: [UserPermissions.MANAGE_DEALERSHIP_ACCOUNTS],
            menu: {
                label: "Dealership Users",
                icon: ["fas", "users-between-lines"],
            },
        },
    },
    {
        path: DCPPathNames.DEALERSHIP_SETTINGS_CONFIGURATION_PATH,
        name: "Settings",
        element: <DealershipSettingsConfiguration />,
        meta: {
            requiresAuthorization: true,
            authorize: [
                UserPermissions.CUSTOMISE_APPEARANCE,
                UserPermissions.CUSTOMISE_SETTINGS,
            ],
            menu: {
                label: "Settings",
                icon: ["fas", "sliders"],
            },
        },
    },
    {
        path: DCPPathNames.DEALERSHIP_AUDIT_VIEW,
        name: "Audit View",
        element: <AuditHistory />,
        meta: {
            requiresAuthorization: true,
            authorize: [UserPermissions.MANAGE_DEALERSHIP_ACCOUNTS],
            menu: {
                label: "Audit History",
                icon: ["fas", "newspaper"],
            },
        },
    },
];

export default dealerRoutes;
